var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgF4Lp3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1424,
    height: 1141,
    viewBox: "0 0 1424 1141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_965)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.34375 -8.54272C381.166 -8.54272 761.988 -8.54272 1142.81 -8.54272C1142.39 289.894 1142.39 588.332 1142.81 886.769C762 887.077 381.178 887.077 0.34375 886.769V-8.54272Z",
    stroke: "#707070",
    strokeOpacity: 0.4,
    strokeWidth: 1.02655,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.34375 844.143C99.0055 844.143 212.053 856.048 308.3 837.272C350.992 828.943 388.818 818.749 433.55 817.963C477.603 817.178 518.631 823.376 561.342 831.256C652.256 848.083 735.691 843.175 827.947 836.585C934.052 828.985 1037.19 844.718 1142.86 844.157",
    stroke: "#707070",
    strokeOpacity: 0.4,
    strokeWidth: 1.02655,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.34375 801.498H164.673C217.582 801.498 255.336 804.752 297.349 776.441C329.556 754.763 353.819 723.465 399.929 719.511C448.813 715.304 498.52 742.774 538.85 760.386C582.581 779.498 626.526 801.246 677.932 801.414C726.243 801.555 774.715 787.392 821.184 778.642C872.733 768.911 920.615 766.121 973.023 774.758C1030.01 784.167 1084.17 798.946 1142.81 801.498",
    stroke: "#707070",
    strokeOpacity: 0.4,
    strokeWidth: 1.02655,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.34375 758.82H164.673C224.865 758.82 257.036 761.624 285.844 714.664C303.272 686.256 318.284 626.858 364.877 618.655C415.443 609.751 481.575 666.456 515.393 688.247C557.566 715.436 607.864 757.684 666.588 758.357C715.722 758.988 769.437 733.468 814.241 719.951C868.564 703.559 912.813 698.23 969.248 713.515C1027.67 729.318 1080.54 752.776 1142.81 758.722",
    stroke: "#707070",
    strokeOpacity: 0.4,
    strokeWidth: 1.02655,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.34375 716.233H164.673C187.182 716.233 217.654 720.523 238.642 713.611C264.802 704.987 272.8 682.425 280.064 662.472C291.283 631.623 295.363 553.352 344.855 542.807C397.961 531.505 470.947 605.318 502.206 629.113C541.982 659.401 597.629 717.453 660.147 715.91C712.394 714.634 764.642 685.062 810.448 668.039C865.057 647.749 909.378 640.766 966.993 659.948C1026.27 679.691 1077.52 709.446 1142.81 716.219",
    stroke: "#707070",
    strokeOpacity: 0.4,
    strokeWidth: 1.02655,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.34375 673.605H164.673C187.111 673.605 217.403 677.812 238.463 671.25C265.142 662.907 274.697 639.49 283.518 619.606C297.403 588.365 308.264 507.626 358.346 497.53C412.347 486.663 484.241 560.026 516.019 584.327C556.081 614.979 611.478 673.325 674.586 671.081C724.687 669.315 775.896 646.865 822.203 633.404C876.795 617.531 920.31 611.039 976.691 627.361C1032.77 643.598 1082.62 666.791 1142.77 673.549",
    stroke: "#707070",
    strokeOpacity: 0.4,
    strokeWidth: 1.02655,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.34375 630.963H164.673C188.13 630.963 217.081 634.693 239.376 628.523C268.72 620.418 283.697 596.118 297.17 575.646C318.892 542.623 346.072 459.543 400.752 450.737C457.258 441.65 525.592 510.877 560 536.664C604.732 570.317 653.652 619.03 719.516 622.998C764.695 625.704 814.491 617.123 859.582 613.758C908.018 610.154 955.184 607.434 1003.51 613.66C1050.32 619.689 1095.25 628.831 1142.88 630.949",
    stroke: "#707070",
    strokeOpacity: 0.4,
    strokeWidth: 1.02655,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.34375 588.335H164.673C189.168 588.335 217.135 591.49 240.646 585.769C273.534 577.776 294.576 552.579 313.31 531.419C344.998 495.663 388.102 412.231 449.69 403.313C507.752 394.9 574.69 461.631 610.726 488.203C659.037 523.777 704.378 564.624 771.334 574.201C816.066 580.595 858.741 588.728 902.793 597.421C947.526 606.227 988.161 611.163 1034 604.124C1070.66 598.515 1105.29 590.747 1142.85 588.363",
    stroke: "#707070",
    strokeOpacity: 0.4,
    strokeWidth: 1.02655,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.34375 545.679H164.673C189.544 545.679 217.099 548.553 241.076 543.085C276.092 535.092 301.268 508.955 323.383 487.782C361.871 451.072 417.089 366.364 482.81 357.376C541.427 349.397 607.864 414.796 644.777 441.593C695.002 478.05 739.144 514.508 806.189 527.029C853.606 535.905 889.57 554.751 931.583 573.064C969.373 589.526 1014.41 603.913 1055.24 584.492C1088.16 568.97 1100.78 550.404 1142.81 545.679",
    stroke: "#707070",
    strokeOpacity: 0.4,
    strokeWidth: 1.02655,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.34375 503.065H164.673C189.723 503.065 216.831 505.758 240.843 499.995C274.571 491.904 300.713 467.071 323.509 447.328C363.481 412.679 421.222 334.604 484.545 325.447C540.013 317.455 609.188 379.783 645.958 404.196C696.344 437.638 742.293 471.936 806.887 484.528C854.697 493.867 891.95 511.689 935.072 529.595C972.182 545.02 1019.9 560.64 1059.61 540.813C1091.58 524.856 1100.26 507.384 1142.79 503.08",
    stroke: "#707070",
    strokeOpacity: 0.4,
    strokeWidth: 1.02655,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.34375 460.428H164.673C231.95 460.428 266.448 455.87 320.342 420.661C363.195 392.617 416.051 339.823 474.525 333.429C528.097 327.582 591.277 368.485 633.773 388.55C685 412.907 733.061 437.305 792.591 444.723C841.886 450.878 887.423 461.914 935.18 472.851C975.242 482.008 1024.09 492.945 1065.03 480.633C1093.5 472.08 1109.76 462.321 1142.81 460.428",
    stroke: "#707070",
    strokeOpacity: 0.4,
    strokeWidth: 1.02655,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.34375 417.8C100.974 417.8 222.556 433.224 316.047 399.571C363.034 382.646 408.59 358.837 461.535 356.102C514.48 353.368 567.891 369.227 617.723 380.964C669.612 393.177 719.712 405.264 774.179 405.572C827.965 405.867 881.358 409.484 934.965 412.289C1004.03 415.907 1073.6 416.257 1142.83 417.729",
    stroke: "#707070",
    strokeOpacity: 0.4,
    strokeWidth: 1.02655,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.34375 375.16C103.228 375.16 210.622 382.101 312.88 372.945C411.023 364.167 506.536 362.428 605.43 365.359C716.277 368.654 824.619 362.442 935.072 355.613C975.242 353.131 1039.19 341.241 1077.29 355.613C1102 364.924 1111.89 373.043 1142.83 375.146",
    stroke: "#707070",
    strokeOpacity: 0.4,
    strokeWidth: 1.02655,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.34375 332.544C200.834 332.544 401.808 335.895 602.102 328.435C714.345 324.228 823.277 320.022 934.732 308.131C971.699 304.205 1043.24 290.365 1077.88 306.911C1085.68 310.641 1087.52 316.502 1094.23 320.653C1110.6 330.735 1121.34 331.758 1142.81 332.544",
    stroke: "#707070",
    strokeOpacity: 0.4,
    strokeWidth: 1.02655,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.34375 289.888C198.419 289.888 396.87 292.692 594.82 286.775C643.363 285.303 692.014 285.218 740.504 283.676C803.273 281.685 864.735 266.176 925.661 255.435C963.397 248.775 1037.4 230.364 1072.38 251.804C1101.46 269.556 1098.08 287.182 1142.81 289.916",
    stroke: "#707070",
    strokeOpacity: 0.4,
    strokeWidth: 1.02655,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.34375 247.265C194.84 247.265 389.534 249.27 583.976 245.596C628.709 244.755 674.443 246.592 718.961 243.619C785.04 239.23 849.669 214.762 911.99 198.342C953.144 187.503 1027.02 162.052 1064.78 191.331C1095.38 215.042 1092.26 241.109 1142.9 247.279",
    stroke: "#707070",
    strokeOpacity: 0.4,
    strokeWidth: 1.02655,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.34375 204.62C191.798 204.62 383.253 205.475 574.708 204.213C615.862 203.947 659.395 207.018 700.424 203.288C769.509 197.034 837.144 164.236 900.199 143.077C944.931 128.101 1017.17 97.3508 1057.98 133.037C1090.19 161.179 1087.52 195.463 1142.9 204.55",
    stroke: "#707070",
    strokeOpacity: 0.4,
    strokeWidth: 1.02655,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.34375 161.993H571.577C611.746 161.993 654.296 165.176 694.287 161.545C764.445 155.178 832.832 119.24 895.905 96.4539C941.585 79.9499 1012.6 48.33 1054.62 85.4465C1087.52 114.528 1086.45 152.486 1142.83 161.979",
    stroke: "#707070",
    strokeOpacity: 0.4,
    strokeWidth: 1.02655,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.34375 119.41H571.577C611.925 119.41 654.171 122.298 694.376 118.891C759.65 113.366 822.883 85.35 883.183 66.6585C931.923 51.5567 992.544 28.7988 1039.67 57.8947C1077.25 81.0873 1091.13 111.473 1142.85 119.382",
    stroke: "#707070",
    strokeOpacity: 0.4,
    strokeWidth: 1.02655,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.34375 76.7251H571.577C612.194 76.7251 653.401 78.3516 693.965 76.5989C751.222 74.131 806.69 57.3465 861.639 45.624C912.169 34.8551 963.88 25.278 1014.64 40.3657C1059.37 53.6166 1093.37 73.5701 1142.81 76.7251",
    stroke: "#707070",
    strokeOpacity: 0.4,
    strokeWidth: 1.02655,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.34375 34.0862H571.577C662.616 34.0862 750.506 31.9969 840.937 23.822C890.358 19.349 941.138 17.6102 990.594 21.929C1041.71 26.3881 1091.01 34.5489 1142.77 34.1283",
    stroke: "#707070",
    strokeOpacity: 0.4,
    strokeWidth: 1.02655,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.565 -8.51562C706.706 33.5507 709.121 75.617 710.088 117.683C711.036 158.46 710.088 192.786 729.018 231.262C745.766 265.518 765.967 297.545 771.443 334.465C775.873 365.505 784.639 396.069 797.584 425.609C809.805 453.751 828.002 486.857 822.849 517.342C815.155 563.236 755.07 600.857 719.964 634.791C677.683 675.665 669.542 705.21 680.6 756.026C690.065 799.761 704.702 842.164 707.654 886.67",
    stroke: "#707070",
    strokeOpacity: 0.4,
    strokeWidth: 1.02655,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.186 -8.54297C653.186 69.4059 636.653 159.316 671.616 233.563C687.541 267.356 706.758 299.13 711.947 335.405C716.348 366.254 722.843 391.494 738.696 420.59C753.011 446.797 769.687 476.58 764.552 505.914C756.446 552.187 696.022 591.603 661.113 626.504C619.601 667.968 609.67 697.568 621.748 748.735C632.734 795.008 650.967 839.542 653.15 886.867",
    stroke: "#707070",
    strokeOpacity: 0.4,
    strokeWidth: 1.02655,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.862 -8.54297C598.862 70.8081 586.481 156.918 612.014 234.264C623.412 268.772 636.974 301.907 640.875 337.649C643.613 362.538 646.905 377.976 665.353 398.883C727.244 468.994 640.982 525.629 586.928 579.769C541.533 625.228 536.828 655.404 552.072 710.931C568.176 769.558 593.942 826.67 598.88 886.839",
    stroke: "#707070",
    strokeOpacity: 0.4,
    strokeWidth: 1.02655,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.377 -8.54297C544.377 72.0842 537.041 155.123 550.389 235.231C556.258 270.455 562.682 305.019 564.704 340.551C564.901 344.071 562.771 364.698 569.589 368.596C576.137 372.368 580.861 368.596 586.068 370.643C591.275 372.69 595.909 368.554 602.53 372.69C609.812 377.247 608.005 394.326 606.985 400.804C599.828 446.082 540.405 484.937 506.498 519.039C456.237 569.518 459.35 601.685 477.869 662.892C500.432 737.349 534.304 810.292 544.252 886.699",
    stroke: "#707070",
    strokeOpacity: 0.4,
    strokeWidth: 1.02655,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.964 -8.54297C489.964 62.2967 488.729 133.207 489.767 204.046C490.232 235.259 492.344 266.445 493.346 297.644C493.829 314.554 484.56 351.32 497.926 364.726C511.937 356.999 513.654 340.888 527.647 333.204C567.441 380.879 426.283 470.621 401.877 507.415C370.672 554.417 404.865 616.198 421.076 663.397C446.395 737.167 478.477 810.629 490.036 886.699",
    stroke: "#707070",
    strokeOpacity: 0.4,
    strokeWidth: 1.02655,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.571 -8.54297V298.092C435.571 314.681 426.535 351.811 440.116 364.824C453.321 355.008 454.43 338.644 467.653 328.843C506.713 373.139 369.51 467.031 346.661 501.946C315.294 549.929 349.327 611.318 365.717 659.526C391.214 734.601 423.404 809.409 435.499 886.684",
    stroke: "#707070",
    strokeOpacity: 0.4,
    strokeWidth: 1.02655,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.16 -8.54297V236.031C381.16 271.745 380.033 307.543 381.16 343.3C381.16 343.37 379.836 368.007 384.739 369.942C386.438 370.587 396.745 370.012 395.152 368.876C394.258 368.231 402.954 366.562 405.548 367.824C411.632 370.783 409.127 389.587 408.411 394.466C402.596 436.196 361.889 473.621 336.016 508.817C297.743 560.783 302.324 595.375 318.338 653.623C339.648 731.207 370.675 807.6 381.16 886.726",
    stroke: "#707070",
    strokeOpacity: 0.4,
    strokeWidth: 1.02655,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.763 -8.54297V236.031C326.763 290.871 319.999 347.773 334.206 401.632C350.453 463.329 326.852 512.939 301.999 571.103C258 674.067 320.965 782.332 326.781 886.783",
    stroke: "#707070",
    strokeOpacity: 0.4,
    strokeWidth: 1.02655,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.353 -8.54297C272.353 137.399 266.985 284.084 274.142 429.942C277.26 494.99 274.371 560.129 265.5 624.85C253.78 712.418 274.16 799.285 272.371 886.825",
    stroke: "#707070",
    strokeOpacity: 0.4,
    strokeWidth: 1.02655,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.959 -8.54297V886.769",
    stroke: "#707070",
    strokeOpacity: 0.4,
    strokeWidth: 1.02655,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.547 -8.54297V886.769",
    stroke: "#707070",
    strokeOpacity: 0.4,
    strokeWidth: 1.02655,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.148 -8.54297V886.769",
    stroke: "#707070",
    strokeOpacity: 0.4,
    strokeWidth: 1.02655,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7363 -8.54297V886.769",
    stroke: "#707070",
    strokeOpacity: 0.4,
    strokeWidth: 1.02655,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    width: 748,
    height: 348,
    transform: "matrix(1 0 0 -1 -13 890)",
    fill: "url(#paint0_linear_188_965)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_188_965)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 141,
    y: 21.1909,
    width: 1125,
    height: 810.043,
    fill: "#272727"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_188_965",
    x: -273,
    y: -392.809,
    width: 1953,
    height: 1638.04,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 207,
    result: "effect1_foregroundBlur_188_965"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_188_965",
    x1: 374,
    y1: 0,
    x2: 374,
    y2: 348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#282828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#282828",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_965"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 712.5,
    height: 895.696,
    fill: "white",
    transform: "translate(0 -8.69604)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgF4Lp3);
export default __webpack_public_path__ + "static/media/F4LP3.34008f4e51b039c045eb73a97d5d1928.svg";
export { ForwardRef as ReactComponent };